// extracted by mini-css-extract-plugin
module.exports = {"container":"shipping-modal_container__EoZgb","modalPadding":"shipping-modal_modalPadding__I6_oI","backlog":"shipping-modal_backlog__I__7_"};